import { apiSlice } from 'src/features/api/api-slice';
import { ApiResponse } from 'src/common/interfaces';

import { CertificateListParams, CertificateResponseDataProps } from './certificates.types';

export const publicProfileCertificatesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserCertificatesList: builder.query<ApiResponse<CertificateResponseDataProps>, CertificateListParams>({
      query: ({ page = 1, limit = 10, sort = 'Newest' }) => ({
        url: `certificates/list`,
        params: { page, limit, sort },
      }),
    }),
  }),
});

export const { useGetUserCertificatesListQuery } = publicProfileCertificatesApiSlice;
